import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateCompanyUserEntity } from '../../domain/entities/UpdateCompanyUserEntity'

export class UpdateCompanyUserModel extends UpdateCompanyUserEntity {
  mealTierId?: number | null
  
  constructor(dataDto: UpdateCompanyUserEntity) {
    super()
    mapEntityProperties<UpdateCompanyUserModel>(this, dataDto, {
      exclude: ['mealTier'],
      map: {
        mealTierId: dataDto.mealTier?.id ?? null,
        maxItemPerMeal: dataDto.maxItemPerMeal ?? null
      }
    })
  }
}

